import { render } from "./ShowStudent.vue?vue&type=template&id=6aeda4c0&scoped=true"
import script from "./ShowStudent.vue?vue&type=script&lang=js"
export * from "./ShowStudent.vue?vue&type=script&lang=js"

import "./ShowStudent.vue?vue&type=style&index=0&id=6aeda4c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aeda4c0"]])

export default __exports__